module.exports = __webpack_public_path__ + "static/media/small.1bbeeeb6.jpg";